import React from "react";
import { SongLearnCanvasBackdrop } from "../SongLearnCanvasBackdrop";
import { WorkbenchLayout } from "./WorkbenchLayout";

export interface LearnWorkbenchShellProps {
  children: React.ReactNode;
  activeModule: string;
  sidebar: React.ReactNode;
  inspector?: React.ReactNode;
  bottom?: React.ReactNode;
  title?: string;
  /** Clase extra en el backdrop (p. ej. min-h). */
  className?: string;
  hideLeftSidebar?: boolean;
  bottomDock?: boolean;
  /** Explore sandbox: layout edge-to-edge sin columnas laterales */
  immersive?: boolean;
}

/**
 * Envuelve páginas tipo “estudio”: canvas contextual + Workbench en modo learnCanvas.
 * Misma base que Escalas (SongLearnCanvasBackdrop + surface learnCanvas).
 */
export const LearnWorkbenchShell: React.FC<LearnWorkbenchShellProps> = ({
  children,
  activeModule,
  sidebar,
  inspector,
  bottom,
  title,
  className = "min-h-[100dvh]",
  hideLeftSidebar = false,
  bottomDock = false,
  immersive = false,
}) => (
  <SongLearnCanvasBackdrop className={className}>
    <WorkbenchLayout
      sidebar={sidebar}
      hideLeftSidebar={hideLeftSidebar || immersive}
      inspector={immersive ? undefined : inspector}
      bottom={bottom}
      bottomDock={bottomDock}
      title={title}
      activeModule={activeModule}
      surface="learnCanvas"
      immersive={immersive}
    >
      {children}
    </WorkbenchLayout>
  </SongLearnCanvasBackdrop>
);

export default LearnWorkbenchShell;
